import { ICompactProduct } from "api/interfaces/get-page-details/common/CompactProduct.type";
import classNames from "classnames";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import { RootState } from "interfaces/generics.type";
import { useTranslation } from "next-i18next";
import { ReactNode } from "react";
import { useSelector } from "react-redux";
import { createVehicleDescription } from "util/vehicle/createVehicleDescription";
import styles from "./fitmentBorder.module.scss";

interface IProps {
  product: ICompactProduct;
  children: ReactNode;
  iconSize: string;
  noFitmentBorder: boolean;
}

export function FitmentBorder(props: IProps) {
  const {
    product, children, iconSize, noFitmentBorder,
  } = props;
  const { category } = product;
  const { tier3 } = category;
  const { selectedVehicle } = useSelector((store: RootState) => store.garage);
  const { t } = useTranslation("product");

  const vehicleDescription = createVehicleDescription(selectedVehicle, false, false, true);

  return (
    <div className={`${styles.container} ${noFitmentBorder ? styles.info_container : styles.green_container}`}>
      <PAText inlineBlock>
        <div className={styles.icon_description_container}>
          <div>
            <div className={classNames(styles.fitment_icon, styles.success_icon, {
              [styles.big_icon]: (iconSize === "big"),
              [styles.small_icon]: iconSize === "small",
            })}
            >
              <i className="fa fa-check" />
            </div>
          </div>

          <div className="d-flex flex-column" style={{ width: "100%" }}>
            <PAText
              component="span"
              bold
              fontSize={FONT_SIZE[2]}
              className={`${styles.fitment_heading} ${styles.success_heading}`}
            >
              <PAText color="medium-grey" fontSize={FONT_SIZE[2]} className={styles.title}>
                {t("However, we have")}
                <PAText bold fontSize={FONT_SIZE[2]} color="black">
                  {` ${tier3} `}
                </PAText>
                {t("for your")}
                <PAText bold color="black">
                  {` ${vehicleDescription}`}
                </PAText>
              </PAText>

            </PAText>

          </div>

        </div>
      </PAText>

      {children}

    </div>
  );
}

export default FitmentBorder;
